"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importStar(require("react"));
const react_sortablejs_1 = require("react-sortablejs");
const uuid = __importStar(require("uuid"));
const EditableValue_1 = __importDefault(require("../EditableValue"));
function EditableList(props) {
    const { currentDepth = 1, maxDepth = 6, listId, listGroup, items, idField = 'id', valueField = 'title', childrenField, savedField, placeholder = lib_i18n_1.default.t('add-new'), canAddInline = false, canAddAtBottom = false, canReorder = false, canDelete = false, maxWidth = 200, autoSelectIdx, onChange, onChangeTitle, onAdd, onDelete, onDragEnd, onSelect, getClassesForItem, beforeItem, afterItem, disabled, selectedId, multiline = false, } = props;
    const [selectedIdx, setSelectedIdx] = (0, react_1.useState)(autoSelectIdx);
    const [mouseOverIdx, setMouseOverIndex] = (0, react_1.useState)();
    const [expandedItems, setExpandedItems] = (0, react_1.useState)({});
    const isTree = !!childrenField;
    const reachedMaxDepth = currentDepth >= maxDepth;
    const group = (0, react_1.useMemo)(() => listGroup || uuid.v4(), [listGroup]);
    const indent = 0 + (isTree ? 24 : 0) + (canReorder ? 24 : 0);
    const doSelect = (0, react_1.useMemo)(() => (idx, afterDragEnd) => {
        setSelectedIdx(idx);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(idx, listId, afterDragEnd);
    }, [onSelect, listId]);
    const doInsertItems = (0, react_1.useMemo)(() => (itemsToInsert, index, deleteCount = 0) => {
        const newItems = [...items];
        newItems.splice(index, deleteCount, ...itemsToInsert);
        onChange === null || onChange === void 0 ? void 0 : onChange(newItems);
    }, [items, onChange]);
    const doCreateNewItem = (0, react_1.useMemo)(() => value => ({
        [valueField]: value,
        [idField]: uuid.v4(),
    }), [idField, valueField]);
    const handleAddNew = (0, react_1.useCallback)(value => {
        doSelect(items.length + 1);
        const newItems = [doCreateNewItem(value)];
        if (!canAddAtBottom)
            newItems.push(doCreateNewItem(''));
        if (onAdd)
            onAdd(newItems, items.length, listId);
        else
            doInsertItems(newItems, items.length);
    }, [doSelect, items, doCreateNewItem, canAddAtBottom, onAdd, listId, doInsertItems]);
    const handleReturnKey = (0, useCallforward_1.default)((idx) => () => {
        if (canAddInline) {
            const insertIdx = idx + 1;
            const itemsToAdd = [doCreateNewItem('')];
            if (onAdd)
                onAdd(itemsToAdd, insertIdx, listId);
            else
                doInsertItems(itemsToAdd, insertIdx);
            doSelect(insertIdx);
        }
        else {
            const last = idx === items.length - 1;
            doSelect(last ? idx : idx + 1);
        }
    }, [doSelect, items, canAddInline, doCreateNewItem, onAdd, listId, doInsertItems]);
    const handleChangeTitle = (0, useCallforward_1.default)((idx) => (title) => {
        if (onChangeTitle) {
            onChangeTitle(items[idx], title);
        }
        else {
            const newItems = [...items];
            newItems[idx][valueField] = title;
            onChange(newItems);
        }
    }, [items, onChange, onChangeTitle, valueField]);
    const handleDelete = (0, useCallforward_1.default)((idx) => () => {
        if (onDelete) {
            onDelete(items[idx]);
        }
        else {
            const newItems = [...items];
            newItems.splice(idx, 1);
            onChange(newItems);
        }
        setTimeout(() => doSelect(idx === 0 ? 0 : idx - 1), 100);
    }, [doSelect, items, onChange, onDelete]);
    const handlePaste = (0, useCallforward_1.default)((idx) => (clipboardData, isEmptyCell) => {
        const itemsToAdd = clipboardData
            .split('\r')
            .join('') // Windows linebreaks
            .split('\n')
            .map(value => value.trim())
            .filter(value => value !== '')
            .map(doCreateNewItem);
        const deleteCount = items[idx] && isEmptyCell ? 1 : 0;
        if (onAdd) {
            onAdd(itemsToAdd, idx - deleteCount + 1, listId, deleteCount);
        }
        else {
            doInsertItems(itemsToAdd, idx - deleteCount + 1, deleteCount);
        }
        doSelect(idx + itemsToAdd.length);
    }, [doSelect, doCreateNewItem, items, onAdd, listId, doInsertItems]);
    const handleSelect = (0, useCallforward_1.default)((idx) => () => {
        doSelect(idx);
    }, [doSelect]);
    const handleSelectNext = (0, useCallforward_1.default)((idx) => () => {
        if (idx === items.length - 1)
            return;
        doSelect(idx + 1);
    }, [doSelect, items]);
    const handleSelectPrev = (0, useCallforward_1.default)((idx) => () => {
        if (idx === 0)
            return;
        doSelect(idx - 1);
    }, [doSelect]);
    const handleDragEnd = (0, react_1.useCallback)(e => {
        if (onDragEnd) {
            onDragEnd(items[e.oldIndex], e.newIndex, e.to.id || null);
            doSelect(e.newIndex, true);
        }
        else {
            const newItems = [...items];
            const moving = newItems.splice(e.oldIndex, 1);
            newItems.splice(e.newIndex, 0, ...moving);
            onChange(newItems);
            doSelect(e.newIndex);
        }
    }, [doSelect, items, onChange, onDragEnd]);
    const handleToggleExpand = (0, useCallforward_1.default)((idx) => () => {
        expandedItems[items[idx][idField]] = !expandedItems[items[idx][idField]];
        setExpandedItems(Object.assign({}, expandedItems));
    }, [expandedItems, items, idField]);
    const handleMouseEnter = (0, useCallforward_1.default)((idx) => () => {
        setMouseOverIndex(idx);
    }, []);
    const handleMouseLeave = (0, useCallforward_1.default)((idx) => () => {
        if (mouseOverIdx === idx)
            setMouseOverIndex(undefined);
    }, [mouseOverIdx]);
    const handleBefore = (0, useCallforward_1.default)((idx) => (inputRef) => {
        return beforeItem === null || beforeItem === void 0 ? void 0 : beforeItem(items[idx], mouseOverIdx === idx, inputRef);
    }, [items, beforeItem, mouseOverIdx]);
    const handleAfter = (0, useCallforward_1.default)((idx) => (inputRef) => {
        return afterItem === null || afterItem === void 0 ? void 0 : afterItem(items[idx], mouseOverIdx === idx, inputRef);
    }, [items, afterItem, mouseOverIdx]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_sortablejs_1.ReactSortable, { id: listId, group: group, handle: ".dragHandle", direction: "vertical", emptyInsertThreshold: 20, list: items, setList: doNothing_1.default, onEnd: handleDragEnd }, items.map((item, idx) => {
            var _a;
            const id = item[idField];
            const value = item[valueField];
            const saved = savedField ? !!item[savedField] : true;
            const canDeleteItem = typeof canDelete === 'function' ? canDelete(item) : canDelete;
            const canDragItem = canReorder;
            const canExpandItem = isTree && !reachedMaxDepth;
            const expanded = !!expandedItems[id];
            const lightenExpander = !((_a = item[childrenField]) === null || _a === void 0 ? void 0 : _a.length);
            return (react_1.default.createElement(Vertical_1.default, { shrink: true, key: item[idField], classes: { root: getClassesForItem === null || getClassesForItem === void 0 ? void 0 : getClassesForItem(item) } },
                react_1.default.createElement(EditableValue_1.default, { disabled: disabled, selected: selectedId ? selectedId === item[idField] : selectedIdx === idx, toneDown: item.toneDown, lightenExpander: lightenExpander, expanded: expanded, multiline: multiline, maxWidth: maxWidth, saved: saved, value: value, spaceForExpand: isTree, canExpand: canExpandItem, canDrag: canDragItem, canDelete: canDeleteItem, before: handleBefore(idx), after: handleAfter(idx), onReturnKey: handleReturnKey(idx), onChange: handleChangeTitle(idx), onPaste: handlePaste(idx), onDelete: handleDelete(idx), onMouseEnter: handleMouseEnter(idx), onMouseLeave: handleMouseLeave(idx), onToggleExpand: handleToggleExpand(idx), onSelect: handleSelect(idx), onSelectPrev: handleSelectPrev(idx), onSelectNext: handleSelectNext(idx) }),
                isTree && expanded && !reachedMaxDepth && (react_1.default.createElement(Pane_1.default, { style: { paddingLeft: 32 } },
                    react_1.default.createElement(EditableList, Object.assign({}, props, { currentDepth: currentDepth + 1, listId: id, listGroup: group, items: item[childrenField] }))))));
        })),
        (canAddAtBottom || (canAddInline && !items.length)) && (react_1.default.createElement(Pane_1.default, { style: { paddingLeft: indent }, classes: { root: 'NewItem' } },
            react_1.default.createElement(EditableValue_1.default, { placeholder: placeholder, onChange: handleAddNew, onPaste: handlePaste(items.length), multiline: multiline, maxWidth: maxWidth })))));
}
exports.default = EditableList;
